import { isGodMode } from './session';

/**
 * Écrans client masqués en God Mode (SPEC §4.3, A19).
 *
 * Le serveur refuse déjà ces données (`GOD_MODE_FORBIDDEN`) : le masquage
 * côté interface évite seulement d'y mener l'intervenant. Il ne protège rien
 * à lui seul et n'est jamais la barrière de sécurité.
 *
 * Correspondance sur segments entiers : `/help` masque `/help` et `/help/x`,
 * pas `/helpful`. Casse, barre finale et barres répétées sont ignorées, comme
 * le routage.
 */
export const GOD_MODE_HIDDEN_PREFIXES = [
  '/results',          // Résultats : vue d'ensemble, insights, points critiques, plan d'action, analyse
  '/settings/billing', // Facturation
  '/settings/users',   // Utilisateurs
  '/settings/account', // Mon compte (profil et mot de passe de l'admin emprunté)
  '/help',             // Aide
  '/benchmark',
  '/synthesis',
  '/manager/results',
];

function normaliser(chemin) {
  return String(chemin || '')
    .split(/[?#]/)[0]
    .toLowerCase()
    .replace(/\/{2,}/g, '/')
    .replace(/\/+$/, '') || '/';
}

export function godModeRouteHidden(chemin) {
  const p = normaliser(chemin);
  return GOD_MODE_HIDDEN_PREFIXES.some((prefixe) => p === prefixe || p.startsWith(`${prefixe}/`));
}

/** Faux uniquement en God Mode sur un écran masqué. */
export function canReach(chemin) {
  return !isGodMode() || !godModeRouteHidden(chemin);
}
